import React, { Component } from 'react';
import { Button, Modal, Select, Form, message } from 'antd';
import { connect } from 'react-redux';

import CategoryEditorForm from './CategoryEditorForm';
import { createCategory, editCategory } from '../../../../../../actions';
import { stringsToRoles, rolesToStrings, roles as roleList } from '../../../../../../utils/roles';

const Option = Select.Option;
const FormItem = Form.Item;

class CategoryEditor extends Component {
  state = {
    fields: {
      newName: {
        value: this.props.category.name,
      },
      newEngName: {
        value: this.props.category.engName,
      },
      newFeaturedImage: {
        value: this.props.category.featuredImage,
      },
    },
    newRoles: this.props.category.roles,
  }

  handleChangeSelect = (value) => {
    this.setState({
      newRoles: stringsToRoles(value),
    });
  }

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  }

  handleOk = () => {
    const type = this.props.type;
    const { newName, newFeaturedImage, newEngName } = this.state.fields;
    const { newRoles } = this.state;
    if (type === 'create') {
      Modal.confirm({
        title: 'Bạn chắc chắn tạo danh mục mới?',
        okText: 'Có',
        okType: 'danger',
        cancelText: 'Không',
        onOk: () => {
          this.props.createCategory({
            data: {
              name: newName.value,
              featuredImage: newFeaturedImage.value,
              engName: newEngName.value,
              roles: newRoles,
            },
            response: {
              success: async () => {
                message.success('Tạo danh mục mới thành công');
                this.props.closeCategoryEditor();
              },
              failure: async (msg = 'Tạo danh mục mới không thành công') => {
                message.error(msg);
              },
            },
          });
        },
        onCancel: () => {

        },
      });
    } else if (type === 'edit') {
      const { name, featuredImage, roles, engName } = this.props.category;

      const data = {};
      if (newName.value !== name && newName.value !== '' && newName.value) data.name = newName.value;
      if (newEngName.value !== engName && newEngName.value !== '' && newEngName.value) data.engName = newEngName.value;
      if (newFeaturedImage.value !== featuredImage && newFeaturedImage.value !== '' && newFeaturedImage.value) {
        data.featuredImage = newFeaturedImage.value;
      }
      if (JSON.stringify(newRoles) !== JSON.stringify(roles) && newRoles.length > 0) data.roles = newRoles;

      Modal.confirm({
        title: 'Bạn chắc chắn sửa thông tin danh mục?',
        okText: 'Có',
        okType: 'danger',
        cancelText: 'Không',
        onOk: () => {
          this.props.editCategory({
            _id: this.props.category._id,
            data,
            response: {
              success: async () => {
                message.success('Sửa thông tin danh mục thành công');
                this.props.closeCategoryEditor();
              },
              failure: async (msg = 'Sửa thông tin danh mục không thành công') => {
                message.error(msg);
              },
            },
          });
        },
        onCancel: () => {

        },
      });
    }
  }

  handleCancel = () => {
    Modal.confirm({
      title: 'Bạn chắc chắn hủy tác vụ?',
      okText: 'Có',
      okType: 'danger',
      cancelText: 'Không',
      onOk: () => {
        this.props.closeCategoryEditor();
      },
      onCancel: () => {

      },
    });
  }

  render() {
    const { fields, newRoles } = this.state;
    const { name, featuredImage, roles, engName } = this.props.category;
    const { newName, newFeaturedImage, newEngName } = this.state.fields;
    const isCreate = this.props.type === 'create';
    const disabled = newName.value === '' || newName.value === undefined ||
     newEngName.value === '' || newEngName.value === undefined ||
                     newRoles.length === 0 ||
      (newName.value === name && newFeaturedImage.value === featuredImage && newEngName === engName &&
                      JSON.stringify(newRoles) === JSON.stringify(roles));

    return (
      <div>
        <CategoryEditorForm
          {...fields}
          onChange={this.handleFormChange}
          formItemLayout={this.props.formItemLayout}
          tailFormItemLayout={this.props.tailFormItemLayout}
          isCreate={isCreate}
        />
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <FormItem
            {...this.props.formItemLayout}
            label="Vai trò"
          >
            <Select
              mode='multiple'
              style={{ width: '100%' }}
              defaultValue={rolesToStrings(this.state.newRoles)}
              onChange={this.handleChangeSelect}
            >
              {roleList.map(role => <Option key={role} value={role}>{role}</Option>)}
            </Select>
          </FormItem>
          <Button type="primary" onClick={this.handleCancel}>Hủy</Button>
          {' '}
          <Button type="primary" onClick={this.handleOk} disabled={disabled}>{isCreate ? 'Tạo danh mục' : 'Chỉnh sửa thông tin'}</Button>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  createCategory,
  editCategory,
};

export default connect(null, mapDispatchToProps)(CategoryEditor);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Categories/CategoryEditor/CategoryEditor.js